// extracted by mini-css-extract-plugin
export default {"l":"_77c255c135"};